/**
 * OrderDesk / orderdesker sheet row keys (column 0).
 * Production Planner SSOT: skip only obvious spreadsheet header labels.
 * Do NOT use substring "order" — e.g. source_id "CPFM-Order" is valid and must be kept.
 */

/**
 * @param {unknown} value
 * @returns {boolean} true when column 0 looks like a header label, not a real order key
 */
export function isOrderDeskOrderSheetHeaderFirstCell(value) {
  const raw = String(value == null ? '' : value).trim();
  const t = raw.toLowerCase();
  if (!t) return true;
  const headerLabels = new Set([
    'order id',
    'order #',
    'order#',
    'order number',
    'order',
    'id',
    'source id',
    'source id#',
    '#',
  ]);
  if (headerLabels.has(t)) return true;
  if (/^order\s*id$/i.test(raw)) return true;
  if (/^order\s*#$/i.test(raw)) return true;
  return false;
}

/** @deprecated Prefer isOrderDeskOrderSheetHeaderFirstCell — alias for Production Planner naming. */
export const isPlannerOrderSheetHeaderFirstCell = isOrderDeskOrderSheetHeaderFirstCell;
